<template>
    <validation-observer #default="{ invalid }" ref="observer">
        <span class="display-none">{{ invalid }}</span>
        <b-form class="mt-4">
            <PlanInputContent
                title="J. Identificarea riscurilor"
                warn="Această secțiune trebuie să identifice riscurile și ipotezele/scenariile. De asemenea, trebuie să indice riscurile și analiza riscurilor, consecințele riscurilor și probabilitatea apariției acestora, precum și identificarea măsurilor corective pentru a aborda riscurile și impactul acestora asupra proiectului."
            >
                <template v-slot:body>
                    <div class="flex table-actions">
                    </div>
                    <b-table :items="items" :fields="fields">
                        <template v-if="tableEdit" v-slot:cell(identified)="data">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-textarea
                                    v-model="data.item.identified"
                                    rows="6"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-textarea>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </template>
                        <template v-if="tableEdit" v-slot:cell(quantification)="data">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-textarea
                                    v-model="data.item.quantification"
                                    rows="6"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-textarea>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </template>
                        <template v-if="tableEdit" v-slot:cell(answer)="data">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-textarea
                                    v-model="data.item.answer"
                                    rows="6"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-textarea>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </template>
                        <template v-if="tableEdit" v-slot:cell(monitoring)="data">
                            <div class="position-relative">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-textarea
                                        v-model="data.item.monitoring"
                                        rows="6"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                    ></b-form-textarea>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                                <b-icon-x-circle-fill font-scale="1.5" class="delete-action" @click="deleteColumn(data.index)"></b-icon-x-circle-fill>
                            </div>
                        </template>
                    </b-table>
                    <div class="flex table-actions">
                        <p v-if="!tableEdit" class="edit flex align-center" @click="editTable()"><b-icon-pencil-square font-scale="1.4"></b-icon-pencil-square> Editează tabelul</p>
                        <p v-if="tableEdit" class="edit flex align-center" @click="editTable()"><b-icon-check-circle-fill font-scale="1.4"></b-icon-check-circle-fill> Salvează tabelul</p>
                        <p class="add flex align-center" @click="addColumn()"><b-icon-check-circle-fill font-scale="1.4"></b-icon-check-circle-fill> Adaugă risc</p>
                    </div>
                </template>
            </PlanInputContent>
            <hr class="mt-5">
            <b-form-checkbox
                v-model="completed"
                switch
                size="lg"
                class="switch-box"
                :disabled="invalid"
                @change="completeForm()"
            >Informațiile sunt complete și corecte</b-form-checkbox>
        </b-form>
    </validation-observer>
</template>

<script>
    import { BForm, BFormInput, BFormCheckbox, BFormTextarea, BIconPencilSquare, BIconCheckCircleFill, BTable, BIconXCircleFill} from "bootstrap-vue";
    import PlanInputContent from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/PlanInputContent'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    export default {
        components: {
            BForm,
            BFormInput,
            PlanInputContent,
            BFormCheckbox,
            BFormTextarea,
            BIconPencilSquare,
            BIconCheckCircleFill,
            BTable,
            BIconXCircleFill,
            ValidationProvider, ValidationObserver
        },
        props: {
            riscuri: null
        },
        data() {
            return {
                completed: null,
                fields: [
                    {
                        key: 'identified',
                        label: 'Risc identificat',
                    },
                    {
                        key: 'quantification',
                        label: 'Cuantificarea riscului',
                    },
                    {
                        key: 'answer',
                        label: 'Răspuns la risc',
                    },
                    {
                        key: 'monitoring',
                        label: 'Monitorizare de risc și răspuns/gestionare',
                    }
                ],
                tableEdit: false,
                items: [],
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            }
        },
        watch: {
            checks: {
                handler: function() {
                    this.completed = this.checks.planDeAfaceriRiscuri;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            },
            riscuri: {
                handler () {
                    if(this.riscuri)
                        this.items = this.riscuri.business_plan_risks
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {

            this.items = this.riscuri ? this.riscuri.business_plan_risks : [{
                                                                                identified: 'Instabilitatea echipei de implementare - schimbări frecvente în rândul membrilor',
                                                                                quantification: 'Impact mediu, probabilitate redusă',
                                                                                answer: 'Echipa de implementare va face parte din echipa întreprinderii sau va fi formată din experți care cunosc foarte bine activitatea acesteia, obiectivele și resusele acesteia.',
                                                                                monitoring: 'Motivarea experților implicați în implementare coroborat cu o planificare mai detaliată a fiecărei activități, incluzând nivelul de lucru al fiecărui expert și profilul poziției'
                                                                            },
                                                                            {
                                                                                identified: 'Respingerea sau aprobarea parțială a cererilor de rambursare de către autoritatea competentă',
                                                                                quantification: 'Impact mare, probabilitate redusă',
                                                                                answer: 'Asumarea colectării și verificării tuturor documentelor justificative care vor fi transmise la solicitarea rambursării cheltuielilor',
                                                                                monitoring: 'Experții vor fi implicați permanent în elaborarea documentației tehnice. Managerul de proiect va verifica raportarea înainte de a o transmite autorității competente'
                                                                            },
                                                                            {
                                                                                identified: 'Schimbări instituționale și legislative ce ar conduce la constrângeri în procesul de elaborare a documentațiilor',
                                                                                quantification: 'Impact mediu, probabilitate medie',
                                                                                answer: 'Expertul/departamentul responsabil de achiții va urmări permanent modificările legislative și bunele practici din domeniul achizițiilor publice, astfel încât să fie menținute standarde superioare de calitate în elaborarea documentațiilor',
                                                                                monitoring: 'Informare periodică asupra legislației din domeniu'
                                                                            },
                                                                            {
                                                                                identified: 'Neîndeplinirea prevederilor contractuale de către operatorii economici contractați ',
                                                                                quantification: 'Impact mediu, probabilitate redusă',
                                                                                answer: 'Evaluarea atentă a ofertanților, mai ales verificarea solvabilității, solicitarea unor informații suplimentare care atestă experiența și stipularea în contractele de achiziție de clauze de asigurare a bunei execuții, precum și de sancțiuni',
                                                                                monitoring: 'Monitorizarea derulării contractelor de achiziții și reluarea în cel mai scurt timp a procedurii de achiziție, dacă este cazul, cu respectarea legislației în vigoare'
                                                                            },
                                                                            {
                                                                                identified: 'Întârzieri în implementare cauzate de procedura de avizare/aprobare de la nivelul instituțiilor implicate',
                                                                                quantification: 'Impact mare, probabilitate medie',
                                                                                answer: 'Se vor solicita întâlniri, dacă va fi cazul, pentru identificarea cauzelor blocajelor și a soluțiilor pentru depășirea acestora',
                                                                                monitoring: 'Managerul de proiect va urmări periodic respectarea termenelor și va atenționa, în scris, autoritățile competente în situația depășirii acestora.'
                                                                            },
                                                                            {
                                                                                identified: 'Neatingerea indicatorilor de proiect asumați',
                                                                                quantification: 'Impact mare, probabilitate redusă',
                                                                                answer: 'La nivelul echipei de management se va realiza pe toată durata proiectului o monitorizare a statusului indicatorilor asumați raportat la numărul de luni de implementare rămase până la finalizarea proiectului',
                                                                                monitoring: 'Întocmirea și respectarea unui plan de monitorizare care cuprinde cuantificarea indicatorilor și măsuri de prevenire a neîndeplinirii acestora'
                                                                            },
                                                                            {
                                                                                identified: 'Riscul aplicării unor corecții financiare',
                                                                                quantification: 'Impact mare, probabilitate redusă',
                                                                                answer: 'Cunoașterea și respectarea criteriilor de eligibilitate a cheltuielilor și a prevederilor ghidului solicitantului, contractului de finanțare, precum și ale legislației în vigoare; evitarea unor abateri de la termenele stabilite prin proiect',
                                                                                monitoring: 'Organizarea unor întâlniri periodice ale echipei de management în scopul înțelegerii comune a condițiilor și termenilor de implementare a proiectului'
                                                                            },
                                                                            {
                                                                                identified: 'Riscul suspendării unor activități sau chiar a proiectului din cauza evoluției pandemiei COVID-19',
                                                                                quantification: 'Impact mare, probabilitate mare',
                                                                                answer: 'Asumarea identificării unor măsuri alternative de desfășurare a activităților',
                                                                                monitoring: 'Comunicare constantă cu autoritățile competente pentru a stabili cele mai bune decizii privind derularea proiectului (suspendarea activităților, după caz, sau replanificarea acestora)'
                                                                            },
                                                                            {
                                                                                identified: 'Riscul cibernetic a apărut relativ recent ca element important în planificarea pentru reziliență, in contextul pandemiei COVID-19',
                                                                                quantification: 'Impact mediu, probabilitate medie',
                                                                                answer: 'Expertul/departamentul  IT va urmări permanent atacurile in mediul online, astfel încât să fie preintampinate situatii care sa puna in pericol activitatea companiei.',
                                                                                monitoring: 'Actualizare periodica a software-ului specializat, analiza de solutii noi care sa preintampine astfel de atacuri, formarea profesionala a angajatilor pentru a evita situatia unui atac cibernetic.'
                                                                            },
            ]
        },
        methods: {
            addColumn() {
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                } else {
                    this.items.push(
                        { identified: 'Editează acest text', quantification: 'Editează acest text', answer: 'Editează acest text', monitoring: 'Editează acest text' },
                    )
                }
            },
            editTable() {
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                } else {
                    this.tableEdit = !this.tableEdit
                }
            },
            deleteColumn(index){
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                } else {
                    this.items.splice( index, 1 );
                }
            },
            completeForm() {
                this.$refs.observer.validate().then((e) => {
                    if(!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else{

                        this.formSend = {
                            business_plan_risks: {
                                business_plan_risks: this.items,
                                checked: this.completed
                            }
                        }
                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.formSend)
                            .then((firstResponse) => {
                                this.$toast.success(firstResponse.data)
                            }).catch((xhr) => {
                                if (xhr.status === 422) {
                                    this.errors.record(xhr.responseJSON.errors);
                                }
                                this.$toast.error(xhr.response.data.message);
                            });
                    }
                })
                if(this.checks.planDeAfaceriRiscuri !== this.completed)
                    this.$store.dispatch('checks/updateChecks', { name: 'planDeAfaceriRiscuri', value: this.completed })
            },
        }
    }
</script>

<style scoped>
.textarea{
    position: relative;
}
.textarea >>> textarea:read-only{
    background: #e5fffb;
    font-size: 12px;
}
.textarea >>> textarea{
    border: 2px solid #9da2b0;
    background: #f8f9f9;
    color: #515679;
    font-size: 12px;
}
.textarea >>> textarea:focus{
    box-shadow: 0 0 0 0.2rem #cdfaee;
    font-size: 12px;
}
span >>> textarea{
    font-size: 12px;
}
.textarea svg{
    position: absolute;
    top: 10px;
    right: 10px;
    color: #9da2b0;
}
.switch-box{
    text-align: right;
    margin-top: 25px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}

table textarea{
    height: auto;
}
table {
    font-size: 12px;
}
.table-actions .edit{
    margin-right: 20px;
}
.table-actions .edit, .table-actions .add{
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
    margin-top: 10px;
    cursor: pointer;
}
.table-actions .add svg{
    color: #01e8c6;
    margin-right: 5px;
}
.table-actions .edit svg{
    margin-right: 5px;
}
.delete-action{
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    right: -40px;
}
.textarea >>> textarea:read-only{
    background: #e5fffb;
    font-size: 12px;
}
</style>
